@if (responsibleEmployeeName()) {
  <div class="dashboard-header-responsible">
    <button
      type="button"
      class="dashboard-header-responsible__trigger"
      [title]="responsibleEmployeeName()"
      [matMenuTriggerFor]="responsibleMenu"
      (menuOpened)="onMenuOpened()"
      (menuClosed)="onMenuClosed()"
    >
      <avatar [imageUrl]="responsibleEmployeeAvatar()" [width]="26" [rounded]="true" />
      <span class="dashboard-header-responsible__name">{{ responsibleEmployeeName() }}</span>
    </button>

    <mat-menu
      #responsibleMenu="matMenu"
      class="dashboard-header-responsible__menu menu-v2"
      xPosition="before"
      yPosition="below"
      [overlapTrigger]="false"
    >
      <div class="dashboard-header-responsible__dropdown" (click)="$event.stopPropagation()">
        <div class="dashboard-header-responsible__search">
          <div class="search">
            <svg-icon class="search-icon" src="/assets/img/search-icon.svg" />
            <input
              type="text"
              [value]="search()"
              [placeholder]="'List.Filters.search' | translate"
              (click)="$event.stopPropagation()"
              (input)="onSearchChange(($any($event.target).value || '').toString())"
            />
          </div>
        </div>

        <div class="dashboard-header-responsible__list">
          @if (loading()) {
            <div class="dashboard-header-responsible__loader">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </div>
          }

          <h5 class="dashboard-header-responsible__list-title">Projekt-Team</h5>

          @for (employee of visibleEmployees(); track employee.id) {
            <button
              type="button"
              class="dashboard-header-responsible__option"
              [class.dashboard-header-responsible__option--selected]="isSelected(employee)"
              [disabled]="saving()"
              (click)="selectEmployee(employee)"
            >
              <avatar [imageUrl]="employeeAvatarUrl(employee)" [width]="48" [rounded]="true" />
              <div class="dashboard-header-responsible__option-content">
                <h5>
                  {{ employee?.userPerson?.previewName || employee?.userPerson?.fullName || employee?.userPerson?.email }}
                </h5>
                @if (employee?.role) {
                  <span>{{ 'ROLES.' + employee.role | translate }}</span>
                }
              </div>
            </button>
          } @empty {
            @if (!loading()) {
              <div class="dashboard-header-responsible__empty">
                {{ 'List.noResult' | translate }}
              </div>
            }
          }
        </div>
      </div>
    </mat-menu>
  </div>
} @else {
  <div class="dashboard-header-responsible dashboard-header-responsible--skeleton">
    <div class="dashboard-header-responsible__trigger">
      <skeleton-item width="26px" height="26px" />
      <skeleton-item width="170px" height="18px" />
    </div>
  </div>
}
